import { Modal } from '../../../../shared/components/ui/Modal/Modal';
import useTranslation from '../../../../shared/hooks/useTranslation';
import HelpSectionView from '../HelpMenuButton/components/HelpSectionView';
import { getHelpSections } from '../HelpMenuButton/helpContent';

import styles from './ShortcutsCheatSheetModal.module.css';

interface ShortcutsCheatSheetModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ShortcutsCheatSheetModal = ({
  isOpen,
  onClose,
}: ShortcutsCheatSheetModalProps) => {
  const { language } = useTranslation();
  const shortcutsSection = getHelpSections(language.code).shortcuts;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={shortcutsSection.title}
      size="lg"
      className={styles.cheatSheetModal}
    >
      <div className={styles.content}>
        <HelpSectionView
          section={shortcutsSection}
          hideHeading
          fullWidth
          compact
          onDarkBackground
        />
      </div>
    </Modal>
  );
};
